import React from "react";
import styled from "styled-components";
//@ts-ignore
import {DynamicCloseIcon} from "../../../assets/icons/DynamicCloseIcon"

interface IProps {
  isOpen: boolean;
  setIsOpen: () => void;
  indicationInfo: {
    title: string;
    icon: any;
    children: any;
  };
}

interface IOpenProps {
  isOpen: boolean;
}

const Overlay = styled.div<IOpenProps>`
  width: ${({isOpen}) => isOpen ? '100vw' : '0px'};
  height: ${({isOpen}) => isOpen ? '100vh' : '0px'};
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isOpen }) =>
    isOpen ? "rgba(0, 0, 0, 0.7)" : "transparent"};
`;

const Container = styled.div<IOpenProps>`
  background-color: #2c2c2c;
  border-radius: 20px;
  height: 65%;
  width: auto;
  aspect-ratio: 9/11;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Title = styled.p`
  color: white;
  font-size: 18px;
  font-weight: 700;
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  justify-content: center;
  `;

export const ReferralModal = (props: IProps) => {
  return (
    <Overlay isOpen={props.isOpen}>
      <Container isOpen={props.isOpen}>
        <TitleSection>
          <TitleContainer>
            {props.indicationInfo.icon}
            <Title>{props.indicationInfo.title}</Title>
          </TitleContainer>
          <CloseButton onClick={props.setIsOpen}>
            <DynamicCloseIcon size={20} />
          </CloseButton>
        </TitleSection>
        {props.indicationInfo.children}
      </Container>
    </Overlay>
  );
};
